module.exports = __webpack_public_path__ + "img/arrow-up-short-wide.072630b0.svg";